import Banner from "components/common/Banner";
import CnpHoldingOverlay from "components/CnpHolding/CnpHoldingOverlay";
import CnpHoldingOverlayMobile from "../CnpHoldingOverlay/CnpHoldingOverlayMobile";

import envs from "config/envs";

const BannerCnpHolding = () => {
  return (
    <section role="banner">
      <Banner
        background={`${envs.HOST_STATIC_CDN}/AreaAberta/Images/banner_ourhistory.webp`}
        width="100vw"
        height="45vw"
      >
        <Banner.Overlay center={false}>
          <CnpHoldingOverlay />
        </Banner.Overlay>
      </Banner>

      <Banner
        mobileBackground={`${envs.HOST_STATIC_CDN}/AreaAberta/Images/banner_ourhistory_mobile.webp`}
        width="100vw"
        height="130vw"
        isMobile
      >
        <Banner.Overlay center={false} isMobile>
          <CnpHoldingOverlayMobile />
        </Banner.Overlay>
      </Banner>
    </section>
  );
};

export default BannerCnpHolding;
